import React from 'react';
import { GeoJSON, Popup } from 'react-leaflet';

/**
 * TraditionalLandsLayer
 * Renders approved community traditional territory boundaries as a neutral
 * purple dashed outline overlay — distinct from the species-score colored
 * StewardshipPolygonLayer.
 */
export default function TraditionalLandsLayer({ polygons = [], interactive = true }) {
  if (!polygons.length) return null;

  return polygons.map((p) => {
    if (!p.geometry?.type || !p.geometry?.coordinates?.length) return null;

    return (
      <GeoJSON
        key={`${p._id}-${interactive}`}
        data={p.geometry}
        interactive={interactive}
        style={{
          color:       '#7c3aed',
          weight:      2.5,
          opacity:     0.85,
          fillColor:   '#8b5cf6',
          fillOpacity: 0.08,
          dashArray:   '7 5',
        }}
      >
        {interactive && <Popup>
          <div style={{ lineHeight: 1.6, fontSize: 13 }}>
            <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 2 }}>
              🏞️ {p.name}
            </div>
            {p.description && (
              <div style={{ color: '#64748b', fontSize: 12, marginBottom: 4 }}>{p.description}</div>
            )}
            <div style={{ fontSize: 11, color: '#94a3b8' }}>Community Traditional Territory</div>
          </div>
        </Popup>}
      </GeoJSON>
    );
  });
}
